import { connectAppStore } from "../../Store/AppStore";
import PageDependencies from "../../Feature/PageDependencies";
import PaymentDataTable from "./PaymentDataTable";

const PaymentCreditsRefunds = (props) => {
    const { 
        Fragment,
        useEffect,
        useState,
        useParams,
        layoutManager,
        useReducerSmart,
        getAppStore,
        pageProfile,
        AppLoading,
        loaModelFromApi,
    } = PageDependencies();
    const debug = layoutManager.Layout_GetDebugModel(props);
    const defaultParams = pageProfile.getDefaultParams(useParams());
    const [init, setInit] = useState(false);
    const { } = defaultParams;
    const defaultViewModel = {
        ...defaultParams,
    };
    const [extraPostModel, setExtraPostModel] = useState({
        ...defaultParams,
      });
    const [viewModel, dispatchViewModel, bindingViewModel] = useReducerSmart(defaultViewModel);
    const [loading, setLoading] = useState({ isLoading: false, text: "" });
    const [appStoreState, appStoreDispatch] = getAppStore(props);
    const getUrl = "api/DefaultModel/Accessor/Get";
    const [reloadForm, setReloadForm] = useState("");
    const [data, setData] = useState([]);
    const postUrl = props.paymentType === "Credit" ? "api/PaymentAdmin/GetPaymentCredits" : "api/PaymentAdmin/GetPaymentRefunds";
    const showRefundColumn = props.paymentType === "Credit" ? false : true;
    const tableId = props.paymentType === "Credit" ? "PaymentCredit_a4a37211-9760-48eb-ba67-280923f54d73" : "PaymentRefund_a4a37211-9760-48eb-ba67-280923f54d73";
    
    useEffect(()=>{
        layoutManager.Layout_HideHeadterButton_Footer_HideSideBar(props);
        //loaModelFromApi.loadDefault(true, getUrl, viewModel, dispatchViewModel, setLoading, "Loading Payments", appStoreDispatch, undefined, setInit);
    },[]);

    return (
        <Fragment>
            {debug && <p>{JSON.stringify(viewModel)}</p>}
            {loading.isLoading && (<AppLoading active><div>{loading.text}</div></AppLoading>)}
            <div className="app-main__inner">
                <div className="app-page-title">
                    <div className="page-title-wrapper">
                        <div className="page-title-heading">
                            <div className="page-title-icon">
                                <i className="pe-7s-credit icon-gradient bg-tempting-azure">
                                </i>
                            </div>
                            <div>
                                Payment {props.paymentType}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div data-parent="#HeatingConditionersList" id="HeatingConditionersListDiv" className="collapse show">
                        <div className="card-body">
                            <PaymentDataTable
                                debug = {debug}
                                data = {data}
                                setData = {setData}
                                extraPostModel = {extraPostModel}
                                url = {postUrl}
                                tableId = {tableId}
                                tableReload = {reloadForm}
                                setTableReload = {setReloadForm}
                                showRefundColumns = {showRefundColumn}
                            ></PaymentDataTable>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
export default connectAppStore(PaymentCreditsRefunds);
